'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchWidgetPubNubClient = fetchWidgetPubNubClient;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _PubNubJS = require('PubNubJS');

var _PubNubJS2 = _interopRequireDefault(_PubNubJS);

var _decorators = require('PubNubJS/decorators');

var _errors = require('PubNubJS/errors');

var _MessagesClient = require('conversations-core/data/MessagesClient');

var _ClientActions = require('conversations-core/actions/ClientActions');

var _ChatActions = require('conversations-core/actions/ChatActions');

var _PubNubStatusActions = require('conversations-core/actions/PubNubStatusActions');

var _PubNubPresenceActions = require('conversations-core/actions/PubNubPresenceActions');

var _Defaults = require('conversations-schema/constants/Defaults');

var _pubNubHelpers = require('conversations-core/utils/pubNubHelpers');

var _prospectUtkSelectors = require('conversations-core/selectors/prospectUtkSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchWidgetPubNubClient(_ref) {
  var store = _ref.store,
      sessionId = _ref.sessionId,
      messageId = _ref.messageId,
      isRestrictedToMaxConcurrentChats = _ref.isRestrictedToMaxConcurrentChats;

  var messagesUtk = (0, _prospectUtkSelectors.getMessagesUtk)(store.getState());
  var dispatch = store.dispatch;

  var circuitBreakerDecorator = (0, _decorators.defineCircuitBreakerDecorator)({
    callLimit: _Defaults.CHAT_CONFIG_CALL_LIMIT,
    callTimeoutInMs: _Defaults.CHAT_CONFIG_CALL_TIMEOUT_IN_MS
  });
  var retryLimitDecorator = (0, _decorators.defineRetryLimitDecorator)({
    retryLimit: _Defaults.MAXIMUM_CHAT_CONFIG_RETRIES
  });

  dispatch((0, _ChatActions.requestedChatConfig)());

  var decoratedFetchWidgetChatConfig = (0, _decorators.decorate)(_decorators.throttleDecorator, circuitBreakerDecorator, retryLimitDecorator, _decorators.exponentialBackoffDecorator, _MessagesClient.fetchWidgetChatConfig.bind(null, {
    uuid: messagesUtk,
    messageId: messageId,
    sessionId: sessionId
  }));

  var configResolver = function configResolver() {
    return decoratedFetchWidgetChatConfig().then(function (config) {
      dispatch((0, _ChatActions.receivedChatConfig)(config));

      if (isRestrictedToMaxConcurrentChats && !config.agentReady) {
        return _q2.default.reject(new _errors.ExpectedPubNubError());
      }

      return (0, _pubNubHelpers.getPubNubConfigArguments)(config, messagesUtk);
    }, function (err) {
      if (err instanceof _errors.RetryError || err instanceof _errors.CircuitBreakerError) {
        dispatch((0, _ClientActions.forceClientOffline)());
      }
      dispatch((0, _ChatActions.requestedChatConfigFailed)(err));
      return _q2.default.reject(err);
    });
  };

  return (0, _PubNubJS2.default)(configResolver).then(function (pubnub) {
    if (!pubnub) return _q2.default.reject(new _errors.ExpectedPubNubError());

    pubnub.client.addListener({
      message: function message(_message) {
        if ((0, _pubNubHelpers.isInternalPubNubCommand)(_message.message)) {
          dispatch((0, _ChatActions.receivedCommandMessage)(_message));
        } else {
          dispatch((0, _ChatActions.receivedPubNubMessage)(_message));
        }
      },
      presence: function presence(_presence) {
        return store.dispatch((0, _PubNubPresenceActions.receivedPubNubPresence)(_presence));
      },
      status: function status(_status) {
        return dispatch((0, _PubNubStatusActions.receivedPubNubStatus)(_status));
      }
    }).subscribe({
      channels: pubnub.config.channel,
      withPresence: true
    });

    dispatch((0, _ChatActions.setCurrentChannel)(pubnub.config.channel[_Defaults.WIDGET_CHANNEL_INDEX]));

    return pubnub;
  });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/pubNubClients/WidgetPubNubClient.js
// module id = 494
// module chunks = 0